export const GET_SHOWS = 'GET_SHOWS';
export const GET_MAIN_SHOW = 'GET_MAIN_SHOW';
export const REMOVE_MAIN_SHOW = 'REMOVE_MAIN_SHOW';
export const GET_SEASONS = 'GET_SEASONS';
export const GET_CREW = 'GET_CREW';
